// 엔드포인트 URL을 생성하는 함수의 타입을 정의합니다.
export interface AdminMembersEndpointsProps {
  get_admin_member_list: (
    isDeleted: boolean,
    page: number,
    size: number,
    permissionType: string,
    keyword?: string // 선택적 매개변수는 마지막에 배치
  ) => string;
}

// 문의 사항 관련 엔드포인트 정의
export const AdminMembersEndpoints: AdminMembersEndpointsProps = {
  get_admin_member_list: (isDeleted, page, size, permissionType, keyword) => {
    let url = `api/admin/members?isDeleted=${isDeleted}&page=${page}&size=${size}&permissionType=${encodeURIComponent(permissionType)}`;
    if (keyword) {
      url += `&keyword=${encodeURIComponent(keyword)}`;
    }

    return url;
  },
};

export default AdminMembersEndpoints;
